module.exports = __webpack_public_path__ + "media/assets/images/category/Halloween@2x-5f1931ffa0c62d6fa40cc189ab5a5f9b.png";